import { BookmarkGroupModel } from './bookmark.group.model';
import { CollectionModel } from 'src/app/organizations/models/collection.model';
import { StoryModel } from 'src/app/story/models/story.model';

export class BookmarkEntryModel {
  // has access to "edit" bookmark
  isOwner: boolean;
  id?: string;
  title?: string;
  description?: string;
  public_access?: boolean;
  add_group_access?: BookmarkGroupModel[];
  remove_group_access?: BookmarkGroupModel[];
  index?: StoryModel;
  collection?: CollectionModel;
  
  addCollection?: CollectionModel;
  removeCollection?: CollectionModel;
}
